import { g as n } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSiren",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 .5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0V1A.5.5 0 0 1 6 .5Zm3.604 1.396a.5.5 0 0 1 0 .708l-.25.25a.5.5 0 1 1-.708-.708l.25-.25a.5.5 0 0 1 .708 0Zm-7.493.215a.5.5 0 0 1 .707 0l.354.353a.5.5 0 0 1-.708.708l-.353-.354a.5.5 0 0 1 0-.707ZM6 4a2 2 0 0 0-2 2v2.5h1.5V6a.5.5 0 0 1 1 0v2.5H8V6a2 2 0 0 0-2-2Zm3 4.586V6a3 3 0 1 0-6 0v2.586A1.5 1.5 0 0 0 2 10v1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a1.5 1.5 0 0 0-1-1.414ZM3.5 9.5a.5.5 0 0 0-.5.5v.5h6V10a.5.5 0 0 0-.5-.5h-5ZM.5 6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 6ZM10 6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 10 6Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  u
], f = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  p
];
function g(e, I, r, S, Z, t) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--siren"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Siren",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, m, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, f)
    ])
  ], 10, h);
}
const A = /* @__PURE__ */ o(c, [["render", g]]);
export {
  A as default
};
//# sourceMappingURL=siren.js.map
